import { useEffect, useState } from 'react';
import { ITimer } from '../interface/timer';
import { LOCAL_STORAGE_NAMES } from '../constants/constants';
import { useUser } from '../context/UserContext';

export const useFilteredTimers = (searchValue?: string, refresh?: string) => {
  const { user } = useUser();
  const currentOrganisation = localStorage.getItem(LOCAL_STORAGE_NAMES.currentOrganisation);
  const { organizationId } = currentOrganisation ? JSON.parse(currentOrganisation) : {};
  const [timers, setTimers] = useState<ITimer[]>([]);

  useEffect(() => {
    const localTimers: ITimer[] = JSON.parse(
      localStorage.getItem(LOCAL_STORAGE_NAMES.timer) ?? '[]',
    )
      .filter((timer: ITimer) => {
        return timer.subject.toLowerCase().includes(searchValue?.toLowerCase() ?? '');
      })
      .filter((val: ITimer) => val.userId === user?.id && val?.organizationId === organizationId)
      .sort(
        (a: ITimer, b: ITimer) =>
          new Date(b?.timerDate ?? '').getTime() - new Date(a?.timerDate ?? '').getTime(),
      );
    setTimers(localTimers);
  }, [refresh, searchValue, user?.id, organizationId]);

  return { timers, count: timers?.length };
};
